import Api from '@/api'
import { rejectWithResponse, unwrap } from '@/utils/storeHelpers'

/**
 * The external supervisors a company admin keeps for a project. They approve
 * a tradie's weekly timesheet from an emailed link, with no account. Results
 * are returned, not stored: the project page's Supervisors tab owns the list.
 *
 * A removed supervisor is hidden, not deleted: a link already emailed keeps
 * working until they decide, and tradies can no longer pick them (API rule).
 */
export default {
  namespaced: true,

  actions: {
    fetchSupervisors(ctx, { projectId }) {
      return rejectWithResponse(async () => {
        const res = await Api.get(`projects/${projectId}/external-supervisors`)
        const data = unwrap(res)
        return Array.isArray(data) ? data : []
      })
    },

    addSupervisor(ctx, { projectId, payload }) {
      return rejectWithResponse(async () => {
        const res = await Api.post(
          `projects/${projectId}/external-supervisors`,
          payload,
        )
        return unwrap(res)
      })
    },

    updateSupervisor(ctx, { projectId, supervisorId, payload }) {
      return rejectWithResponse(async () => {
        const res = await Api.put(
          `projects/${projectId}/external-supervisors/${supervisorId}`,
          payload,
        )
        return unwrap(res)
      })
    },

    removeSupervisor(ctx, { projectId, supervisorId }) {
      return rejectWithResponse(async () => {
        await Api.delete(
          `projects/${projectId}/external-supervisors/${supervisorId}`,
        )
      })
    },
  },
}
